import { IImageConfig, IMAGES_ICONS_RESOLUTIONS, IMAGES_RESOLUTIONS } from "../../base/base";


// **Avatar Image:**
export const Icon_Avatar: IImageConfig = {
  typeDescription: 'Icon_Avatar',
  aspectRatio: { w: 1, h: 1 },
  defaultResolution: IMAGES_RESOLUTIONS.xxs,
  resolutions: IMAGES_ICONS_RESOLUTIONS,
  pathAccepted: [/^projects\/[^\/]+\/clients\/[^\/]+\/[^\/]+\.(?!(jpeg|jpg|png)$)[^\/]+$/i],
};
